<div class="flex flex-col gap-[1rem]">
  @for (dataType of dataTypes; track dataType) {
    <div
      class="flex justify-between w-[50rem] clickable card kpi-metric-group activate-button-on-hover"
      [attr.data-qa]="'kpi-metric-group-wrapper-' + $index"
      (click)="emit(dataType.type)">
      <div class="flex flex-col gap-[1rem] w-[22rem]">
        <span
          [attr.data-qa]="'kpi-metric-group-header-' + $index"
          class="font-3 bold500 black-12">
          {{ dataType.header }}
        </span>
        <div class="flex flex-wrap gap-[0.5rem]">
          @for (chip of dataType.chips; track chip.name) {
            <div class="flex items-center gap-[0.5rem] pt-[0.3rem] pb-[0.3rem] pr-[0.5rem] pl-[0.5rem] rounded-[0.5rem] bg-black-3 font-3 black-9">
              <app-all-icons
                [attr.data-qa]="'kpi-metric-group-chip-icon-' + $index"
                [iconNameAndStyling]="chip.icon"/>
              <span [attr.data-qa]="'kpi-metric-group-chip-name-' + $index">{{ chip.name }}</span>
            </div>
          }
        </div>
        <span class="font-3 black-9">{{ dataType.text }}</span>
        <app-button
          [attr.data-qa]="'kpi-metric-group-data-type-select-' + $index"
          [type]="'accent-light'"
          [size]="'small'">
          Select
        </app-button>
      </div>
      <div>
        <img
          [attr.data-qa]="'kpi-metric-group-image-' + $index"
          class="w-full h-[12rem]"
          [src]="dataType.img"
          alt="metrics with numbers">
      </div>
    </div>
  }
</div>
